<template>
    <Layout>
        <div style="display: flex;justify-content: center;padding:50px 0;align-items: center;width: 100%;">
            <div style="width:80%;">
                <p style="text-align:center;padding:10px 0 0 0px;">{{ $t('ji-huo-zhang-hao') }}: {{ mail }}</p>
                <div style="padding:30px 0px;">
                    <el-input v-model="verify_code" size="medium" :placeholder="$t('shu-ru-you-jian-zhong-de-ji-huo-ma')"> </el-input>
                    <el-button type="warning" size="medium" style="width:100%;margin-top: 10px;" @click="active">
                        {{ $t('ji-huo') }}
                    </el-button>
                </div>
                <div class="send-mail" @click="sendCode">{{ $t('wei-shou-dao-you-jian-dian-ji-zhong-xin-fa-song') }}</div>
                <div class="send-mail" @click="updateMail" style="margin-top: 10px;">{{ $t('button.mail_reset') }}</div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import { sendCode, active } from '@/api/user'
import { CaptchaCode } from '@/utils/captcha'
import config from '@/config/config.js'
import Cookies from 'js-cookie'
import qs from 'qs'
export default {
    components: { Layout },
    name: 'Active',
    data () {
        return {
            verify_code: '',
            mail: ''
        }
    },
    async mounted () {
        const { mail = '', verify_code = '' } = this.$route.query || {}
        if (mail === '') {
            this.$message.error(this.$t('ji-huo-you-xiang-wei-kong-qing-zhong-xin-zhu-ce'))
            return
        }
        this.mail = mail
        this.verify_code = verify_code
    },
    methods: {
        updateMail () {
            this.$router.push({ name: 'regist' })
        },
        // 激活
        async active () {
            try {
                const loginResponse = await active({
                    mail: this.mail,
                    verify_code: this.verify_code
                })
                const { token = '' } = loginResponse.data || {}
                if (token === '') {
                    throw new Error(loginResponse.msg)
                }
                this.$message.success(this.$t('ji-huo-cheng-gong'))
                Cookies.set(config.COOKIES.TOKEN, token, { domain: config.COOKIES.SET_DOMAIN })
                this.jumpRef(token)
            } catch (err) {
                console.error('login Err', err)
                this.$message.error(err.msg || err || this.$t('message.login_fail'))
            }
        },
        // 发送验证码
        async sendCode () {
            // 验证码
            let captchaData = {}
            try {
                captchaData = await CaptchaCode()
            } catch (err) {
                console.error('CaptchaCode Err:' + err)
                this.$message.error(err.msg || err || this.$t('message.verify_code_fail'))
                throw err
            }

            const { captcha_id, captcha_value } = captchaData || {}

            try {
                await sendCode({
                    captcha_id,
                    captcha_value,
                    mail: this.mail,
                    product: 'regist'
                })

                this.$message.success(this.$t('fa-song-cheng-gong-qing-an-zhao-you-jian-ti-shi-jin-hang-ji-huo'))
            } catch (err) {
                console.error('sendCode err', err)
                this.$message.error(err.msg || err || this.$t('message.send_code_fail'))
            }
        },
        jumpRef (token) {
            setTimeout(() => {
                const { ref = '' } = qs.parse(location.href.split('?')[1])
                if (ref !== '') {
                    console.log('ref', ref.replace(/__TOKEN__/g, token))
                    location.href = ref.replace(/__TOKEN__/g, token)
                    return
                }
                location.href = config.ADMIN_INDEX
            }, 500)
        }
    }
}
</script>

<style scoped>
.send-mail {
    text-align: center;
    padding: 0px 0;
    cursor: pointer;
}
.send-mail:hover {
    color: #e7a23b;
}
</style>
